import { AssetManager } from "../AssetManager";
import { GroundTypes } from "../consts/GroundTypes";
import { Game } from "../logic/Game";
import { Field } from "../models/Field";
import { GameView } from "./GameView";

export class GameMapView {

    public constructor(
        public game: Game,
        protected assets: AssetManager,
        protected game_view: GameView,
        protected context: CanvasRenderingContext2D,
    ) {

    }

    public update() {
        for (let y = 0; y < this.game.map.height; y++) {
            for (let x = 0; x < this.game.map.width; x++) {
                this.update_field(x, y);
            }
        }
    }

    private update_field(x: number, y: number) {
        const field = this.game.map.at(x, y);
        const screen_x = x * this.game_view.field_width;
        const screen_y = y * this.game_view.field_width;
        const ground_image = this.get_ground_image_for_field(field);
        const tower_image = this.get_tower_image_for_field(field);
        //
        this.context.drawImage(ground_image, screen_x, screen_y, this.game_view.field_width, this.game_view.field_height);
        if (tower_image) {
            this.context.drawImage(tower_image, screen_x, screen_y, this.game_view.field_width, this.game_view.field_height);
        }
    }

    public get_tower_image_for_field(field: Field): HTMLImageElement | null {
        if (field.tower === null) return null;
        return this.assets.get("objects.tower");
    }


    public get_ground_image_for_field(field: Field): HTMLImageElement {
        switch (field.ground) {
            case GroundTypes.GRAS:
                return this.assets.get("terrain.gras");
            case GroundTypes.PATH:
                return this.assets.get("terrain.stone");
        }
    }
}